module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "search-tips"
  }, [_l((tipsData), function(tip) {
    return _h('div', {
      staticClass: "search-tip",
      on: {
        "click": function($event) {
          handleClick(tip.name)
        }
      }
    }, [_h('span', {
      class: tip.tag
    }, [_s(tip.name)])])
  })])
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-6a4f7e62!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchTip.vue
 ** module id = 75
 ** module chunks = 1
 **/